module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-viewer",
    class: {
      loaderAnimationIn: _vm.show
    },
    attrs: {
      "id": "printscale-modal"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loader-contents"
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h2', {
    staticClass: "loader-title"
  }, [_vm._v(_vm._s(_vm.$t('heading.title')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "height": "150px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bt_desc_img",
    staticStyle: {
      "display": "block",
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn btn-info btn-large desc_img",
    attrs: {
      "href": _vm.printScaleModalUrl,
      "id": "bt_a_desc_img",
      "type": "text/html",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.anar')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-bar"
  }, [_c('div', {
    staticClass: "bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "div_msg_export"
    }
  }, [_c('span', {
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v("Accedeix a aquesta eina per generar imatges imprimibles a escala")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://betaportal.icgc.cat/wordpress/faq-dinstamaps/#escala"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-info-sign"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79045bad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/components/printscale-modal/printscale-modal.vue
// module id = 136
// module chunks = 0